import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Box } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const ESwitch = ({ name, control, label, rules, error, tooltipText, bgColor = REGISTRATION_FIELD_FILL_BG, ...rest }) => {
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [label, tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    return (_jsx(Controller, { name: name, control: control, rules: rules, defaultValue: false, render: ({ field }) => (_jsxs(Box, { width: '100%', children: [_jsx(Box, { sx: {
                        background: bgColor,
                        borderRadius: '12px',
                        padding: '12px',
                        width: '100%'
                    }, children: _jsx(FormControlLabel, { control: _jsx(Switch, { ...field, checked: !!field.value, color: 'primary', ...rest }), label: styledLabel, sx: {
                            '.MuiTypography-root': {
                                fontSize: '14px',
                                fontWeight: 400
                            }
                        } }) }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] })) }));
};
export default ESwitch;
